<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
            </li>
            <li class="breadcrumb-item router-link active">
              เปลี่ยนแปลงเบอร์มือถือ
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          เปลี่ยนแปลงเบอร์มือถือ
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div class="title d-none d-lg-block border-bottom" style="font-family: DB Heavent; color: #0057a8">
          เปลี่ยนแปลงเบอร์มือถือ
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              เบอร์มือถือเดิม
            </div>
          </div>
          <div class="d-lg-flex align-items-center" style="font-family: monospace;">
            <div class="blue-1 fs-6 mt-1 mt-lg-1">{{ this.$store.state.Mobile_Phone }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="form-group fs-5 font-family">
              <label class="field a-field page__field">
                เปลี่ยนเป็น<span class="required">*</span>
                <input v-model="MobilePhone" type="text" class="field__input a-field__input fs-6"
                  style="font-family: monospace;" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  maxlength="10" />
              </label>
              <span class="text-danger" style="display: inline-block"></span>
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button type="button" class="btn btn-light btn-cancel font-family d-inline-block" data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <button type="button" class="btn btn-continue font-family d-inline-block" @click="EnterNext()">ขอ
              OTP</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>

  <!-- Modal -->
  <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light fw-normal popup_cancel" data-bs-dismiss="modal">
            ไม่ต้องการ
          </button>
          <router-link to="/AgenteService">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
              @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "EditMobilePhone",
  components: {
    Menu,
    LoadingBs5
  },
  data() {
    return {
      MobilePhone: this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.MOBILE_PHONE,
      Loading: false,

    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
    if (this.$store.state.Email == '' || this.$store.state.Email == null) {
      Swal.fire({
        icon: 'error',
        html: '<lable class="fs-4 fw-normal font-family">ท่านไม่มีอีเมลในฐานข้อมูล กรุณาดำเนินการเพิ่มอีเมลที่<br>เมนู ขอเปลี่ยนแปลงอีเมล ก่อนการเปลี่ยนแปลงเบอร์มือถือ</lable>',
        confirmButtonText: 'รับทราบ' 
      });
      this.$router.push('/AgenteService');
    }
  },
  methods: {
    EnterNext() {
      if (this.MobilePhone !== '') {
        this.Loading = true;
        let result = this.ValidateMobilePhone(this.MobilePhone);
        if (result === false) {
            this.MobilePhone = '';

          this.Loading = false;
        }
        else {
          let AuthorizeToken = localStorage.getItem("AuthorizeToken");
          this.Loading = true;
          const requestBody = {
            newMobileNo: this.MobilePhone
          }
          http.post("AgencyERequest/SendSMSOTP",
            requestBody,
            { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
              this.Loading = false;
              //validate response ด้วย
              if (res.status == '200') {
                this.$store.state.Otp.KEY = this.MobilePhone;
                this.$store.state.Otp.ISEMAIL = false;
                this.$store.state.Otp.REFERENCE = res.data.reference != null ? res.data.reference : null;
                this.$router.push('/CheckOTP');
              }
              else {
                Swal.fire({
                  icon: 'error',
                  html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการส่ง OTP</lable>',
                  confirmButtonText: 'รับทราบ' 
                });
                this.ClearData();
              }
            }).catch((error) => {
              this.Loading = false;
              console.log('error :>> ', error);
              Swal.fire({
                icon: 'error', 
                title: `<lable class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</lable>`,
                confirmButtonText: 'รับทราบ' 
              });

              this.ClearData();
            });
        }
      }
      else {
        this.ClearData();
      }
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.MOBILE_PHONE = '';
      this.$store.state.EditAgentInfo.CHANGE_MOBILE_PHONE.SUCCESS = false;
      this.MobilePhone = '';
    },
    ValidateMobilePhone(val) {
      let result = val.substr(0, 2);
      this.$store.commit('ValidateMobliePhone', result);

      if (val.length != 10) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณากรอกรูปแบบเบอร์มือถือให้ถูกต้อง</lable>',
          confirmButtonText: 'รับทราบ' 
        });
        return false;
      }
      else if (!this.$store.state.BoolMobilePhone) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณากรอกรูปแบบเบอร์มือถือให้ถูกต้อง</lable>',
          confirmButtonText: 'รับทราบ' 
        });
        return false;
      }
      else {
        return true;
      }
    },

  },
};
</script>